<template>
  <div class="dankal-image-upload">
    <p v-for="(item, index) in list" :key="index">
      <img class="upload_img" :src="imgDomain + item" alt="" />
      <img class="close" src="@/assets/images/ic_delete.png" @click="onDeleted(index)" />
    </p>
    <div v-if="list.length < limit" class="add-box">
      <img class="add" src="@/assets/images/pic_add_1.png" alt="" @click="onSelected" />
      <!--       <span v-if="type == 1">上传图片({{ list.length }}/{{ limit }})</span>
      <span v-if="type == 2">尺寸：695*418像素，图片格式JPG,png</span> -->
    </div>
    <input id="file" ref="input" type="file" accept="image/*" style="display: none" @change="onFileChanged" />
  </div>
</template>

<script>
import ImageCompressor from "image-compressor.js";
import { uploadImg, qiniuInfo, uploadFile } from "@/api/common";
import { mapState, mapActions } from "vuex";
import { imgDomain } from "@/configs/env";
export default {
  name: "DankalImageUpload",
  props: {
    value: {
      type: Array,
      required: true,
    },
    limit: {
      type: Number,
      default: 3,
    },
    quatity: {
      type: Number,
      default: 0.6,
    },
    // 1是帖子上传图片，2是上传封面图，3是上传反馈
    type: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      imgDomain,
      list: [],
      toast: "",
    };
  },

  watch: {
    value(n) {
      this.list = n;
    },
  },

  mounted() {
    this.list = this.value;
  },

  methods: {
    onSelected() {
      const { limit, list } = this;
      if (limit && list.length >= limit) {
        this.$message(`只能上传${limit}张图片`);
        return;
      }
      this.$refs.input.click();
    },

    onDeleted(index) {
      // Array.prototype.splice(this.list, index, 1);
      this.list.splice(index, 1);
      this.$emit("input", this.list);
    },

    onFileChanged(event) {
      const file = event.target.files[0];
      const type = file.type;
      if (type.indexOf("image")) {
        this.$message("只能上传图片");
        return;
      }
      if (!file) return;

      // eslint-disable-next-line
      new ImageCompressor(file, {
        quatity: this.quatity,
        // eslint-disable-next-line
        success: (result) => {
          this.upload(result);
        },
        // eslint-disable-next-line
        error: (error) => {
          this.$message(`${error.message}`);
        },
      });
    },

    async upload(file) {
      const formData = new FormData();
      formData.append("file", file);
      const res = await uploadFile(formData).catch(() => {});
      if (res.result) {
        this.list.push(res.result);
        this.$emit("input", this.list);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.dankal-image-upload {
  display: flex;
  flex-wrap: wrap;

  p {
    position: relative;
    width: 150px;
    height: 150px;
    margin: 20px 10px 20px 30px;
    float: left;

    .upload_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .close {
      width: 20px;
      height: 20px;
      position: absolute;
      cursor: pointer;
    }
  }

  .add-box {
    display: flex;
    flex-direction: column;
    // padding-left: 20px;
    // margin-top: 20px;

    .add {
      width: 150px;
      height: 150px;
    }

    span {
      color: #cfcfcf;
      font-size: 0.22rem;
    }
  }
}
</style>
